import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
const purchases = [{
  name: 'Mirta G.',
  city: 'Buenos Aires',
  product: 'Sistema Rescate Intestinal +55™',
  time: 13
}, {
  name: 'Carmen S.',
  city: 'Córdoba',
  product: 'Sistema Rescate Intestinal +55™',
  time: 8
}, {
  name: 'Elena R.',
  city: 'Rosario',
  product: 'Sistema Rescate Intestinal +55™',
  time: 22
}, {
  name: 'Diana F.',
  city: 'Mendoza',
  product: 'Sistema Rescate Intestinal +55™',
  time: 5
}, {
  name: 'Susana M.',
  city: 'Mar del Plata',
  product: 'Sistema Rescate Intestinal +55™',
  time: 31
}, {
  name: 'Graciela P.',
  city: 'Tucumán',
  product: 'Sistema Rescate Intestinal +55™',
  time: 17
}, {
  name: 'Norma T.',
  city: 'La Plata',
  product: 'Sistema Rescate Intestinal +55™',
  time: 3
}, {
  name: 'Beatriz B.',
  city: 'Santa Fe',
  product: 'Sistema Rescate Intestinal +55™',
  time: 45
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    // Show first popup after 40 seconds, then every 40 seconds
    const showInterval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % purchases.length);
      setVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setVisible(false);
      }, 5000);
    }, 40000);
    return () => clearInterval(showInterval);
  }, []);
  const purchase = purchases[currentIndex];
  return <AnimatePresence data-id="element-225">
      {visible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-6 left-6 z-50 max-w-xs" data-id="element-226">
          <div className="bg-[#1a1a1a] border border-green-800/50 rounded-lg px-4 py-3 shadow-xl shadow-black/40" data-id="element-227">
            <div className="flex items-center gap-1.5 mb-1.5" data-id="element-228">
              <CheckCircleIcon className="w-4 h-4 text-green-500" data-id="element-229" />
              <span className="text-green-500 text-xs font-bold uppercase tracking-wider" data-id="element-230">
                Compra verificada
              </span>
            </div>
            <p className="text-white text-sm font-semibold" data-id="element-231">
              {purchase.name} de {purchase.city}
            </p>
            <p className="text-gray-300 text-sm" data-id="element-232">
              compró{' '}
              <span className="font-medium text-white" data-id="element-233">{purchase.product}</span>
            </p>
            <p className="text-gray-500 text-xs mt-1" data-id="element-234">
              hace {purchase.time} minutos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}